var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 1L17 8L10 15M1 8H17H1Z","strokeWidth":"1.25","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"width":"18","height":"15","viewBox":"0 0 18 15","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
